import { useEffect, useState } from 'react';
import { fetchGitUserDetails } from 'common/services/repositories.service';
import { useDebounceCallback } from '@react-hook/debounce';

const useGithubOrgs = integration => {
  const integrationId = integration?.id;
  const isOnPrem = integration?.is_on_prem;

  const [githubOrgs, setGithubOrgs] = useState([]);
  const [isLoading, setIsLoading] = useState(!isOnPrem);

  const fetchGithubOrgs = useDebounceCallback(async () => {
    setGithubOrgs([]);
    try {
      setIsLoading(true);
      const res = await fetchGitUserDetails(integrationId);
      setGithubOrgs(res?.orgs || []);
    } catch (e) {
      setGithubOrgs([]);
    } finally {
      setIsLoading(false);
    }
  }, 200);

  useEffect(() => {
    if (!!integrationId && !isOnPrem) fetchGithubOrgs();
  }, [integrationId]);

  return { githubOrgs, isLoading };
};

export default useGithubOrgs;
